import BaseNode from '@appblocks/codegeneration/Nodes/BaseNode';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    Setting,
    TibboDataType,
} from '@appblocks/codegeneration/types';
import * as zephyr from './zephyr';
import * as tios from './tios';

export default class SocketDataNode extends BaseNode {
    constructor() {
        super();
        this.name = 'On Socket Data Received';
        this.id = 'node_socket_data_arrival';
        this.linkedFeature = 'socket';

        this.outputs = [
            {
                name: 'Data Arrival',
                portId: 'sock_data_arrival',
                params: [
                    {
                        name: 'data',
                        dataType: TibboDataType.STRING,
                    },
                ],
            },
        ];

        const settings: Setting[] = [
            {
                id: 'SOCKET',
                name: 'Socket',
                settingType: SettingType.OPTION,
                refId: 'socket_connection',
                required: true,
                default: '',
                options: [],
            },
        ];

        this.settings = this.settings.concat(settings);
    }

    getSettingValue(settingId: string): string {
        if (settingId === 'DISPLAY_NAME') {
            const project: ProjectConfiguration = this.project;
            const value = super.getSettingValue(settingId);
            if (value !== '') {
                return value;
            }
            const SOCKET = project.getFeature(this.getSettingValue('SOCKET'));
            if (SOCKET) {
                return `On SOCKET ${SOCKET.getSettingValue('NAME')} data received`;
            }
        }
        return super.getSettingValue(settingId);
    }

    getName(): string {
        const project: ProjectConfiguration = this.project;
        const SOCKET = project.getFeature(this.getSettingValue('SOCKET'));
        if (SOCKET) {
            return `On SOCKET ${SOCKET.getSettingValue('NAME')} data received`;
        }
        return super.getName();
    }

    getCodeBlocks(): CodeBlock[] {
        switch (this.project.runtime) {
            case 'zephyr':
                return zephyr.getCodeBlocks(this);
            case 'tios':
                return tios.getCodeBlocks(this);
            default:
                return [];
        }
    }
}
